import { Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { forwardRef } from '../../system';

import DisplayNames from './enums';

import { getChild } from '_helpers/index';
import { Button, ButtonProps, Menu, MenuButton, MenuList } from 'index';

const hasItems = (children: React.ReactNode): boolean => {
  const tabItem = getChild(DisplayNames.NavBarTabItem, children);
  return !!tabItem;
};

export type NavBarTabProps = ButtonProps & {
  text: string;
  isActive?: boolean;
};

const NavBarTab = forwardRef<NavBarTabProps, 'div'>(
  (props: NavBarTabProps, ref): React.ReactElement => {
    const { sx, text, isActive, children, ...rest } = props;
    const navBarTheme = useMultiStyleConfig('NavBarTheme', { isActive });
    let mergedProps = {
      sx: navBarTheme.navBarTabButton,
      variant: 'ghost',
      ...rest
    };

    if (isActive) {
      mergedProps = {
        'aria-current': 'page',
        ...mergedProps
      };
    }

    return (
      <Box __css={navBarTheme.navBarTab} ref={ref}>
        {hasItems(children) ? (
          <Menu>
            <MenuButton {...mergedProps}>{text}</MenuButton>
            <MenuList>{children}</MenuList>
          </Menu>
        ) : (
          <Button {...mergedProps}>
            <span>{text}</span>
          </Button>
        )}
      </Box>
    );
  }
);

NavBarTab.displayName = DisplayNames.NavBarTab;

export default NavBarTab;
